// Shared so every product that hosts the `EventSkeleton` derives the same keys.
// A rename here breaks the build in every product instead of silently dropping a CSS class.
export const eventSkeletonClassKeys = ['eventSkeleton'];
export const eventSkeletonSlots = {
  eventSkeleton: ['eventSkeleton']
};